import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { CHECKOUT_URL, PRICE_LABEL } from "../config/pricing";
import { track, EVENTS } from "../lib/analytics";

export function BuyButton({
  label = "Get all 100 messages",
  withPrice = true,
  source = "hero",
  testid,
  className = "",
  small = false,
}) {
  const onClick = () => {
    if (source === "hero") track(EVENTS.HERO_CTA);
    if (source === "pricing") track(EVENTS.PRICING_CTA);
    track(EVENTS.CHECKOUT_STARTED, { source });
    window.location.href = CHECKOUT_URL;
  };

  return (
    <motion.button
      type="button"
      data-testid={testid}
      onClick={onClick}
      whileHover={{ y: -2 }}
      whileTap={{ scale: 0.98 }}
      transition={{ duration: 0.18 }}
      className={`group inline-flex items-center justify-center gap-2.5 rounded-full bg-ink font-medium text-paper shadow-[0_10px_30px_-12px_rgba(20,19,17,0.5)] transition-colors hover:bg-black ${
        small ? "px-4 py-2 text-sm" : "px-7 py-3.5 text-base"
      } ${className}`}
    >
      <span>
        {label}
        {withPrice ? ` — ${PRICE_LABEL}` : ""}
      </span>
      <ArrowUpRight
        className={`${small ? "h-4 w-4" : "h-5 w-5"} transition-transform duration-200 group-hover:translate-x-0.5 group-hover:-translate-y-0.5`}
      />
    </motion.button>
  );
}
